import {MediaDetectionType} from '@legit-health/ui';

const detectionColors = {
  [MediaDetectionType.Treatment]: 'goldenrod',
  [MediaDetectionType.AcneLesion]: '#04AF65',
  [MediaDetectionType.Wheal]: '#04AF65',
  [MediaDetectionType.DrainingTunnel]: '#04AF65',
  [MediaDetectionType.NonDrainingTunnel]: '#191970',
  [MediaDetectionType.Nodule]: '#8671FF',
  [MediaDetectionType.ActinicKeratosisLesion]: '#04af65',
  [MediaDetectionType.NewActinicKeratosisLesion]: 'blue',
  [MediaDetectionType.Lesion]: '#04AF65',
  [MediaDetectionType.SuspiciousLesion]: 'red',
  [MediaDetectionType.Abscess]: 'slategrey',
  [MediaDetectionType.Acne]: '#04AF65'
};

export default detectionColors;
